import { render } from "./BalancedDetails.vue?vue&type=template&id=1a7d6b7a"
import script from "./BalancedDetails.vue?vue&type=script&lang=js"
export * from "./BalancedDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__